import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { UserService } from '@lciapps/lci-core';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { UserClaim } from '../features/activities/shared/models/user-claim.enum';

@Injectable()
export class MemberGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(private userService: UserService, private router: Router) { }

  /**
   * Called by angular when a access is attempted for a route
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {boolean}
   */
  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const url: string = state.url;

    return this.checkIfMember(url);
  }

  /**
   * Called by angular when a child route is tried to access
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {boolean}
   */
  public canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.canActivate(route, state);
  }

  /**
   * Returns whether a route can load or not
   * @param {Route} route
   * @returns {boolean}
   */
  public canLoad(route: Route): Observable<boolean> {
    const url = `/${route.path}`;

    return this.checkIfMember(url);
  }

  /**
   * Returns if the current user is considered authorized and logged in.
   * If not redirects the browser to the specified redirect url.
   * @param {string} url
   * @returns {boolean}
   */
  public checkIfMember(url: string): Observable<boolean> {
    return this.userService.userLoaded.pipe(
      mergeMap(user => {
        if (user.claims.find(c => c.claimType === UserClaim.MyLion)) {
          return of(true);
        } else {
          this.router.navigate(['/nonmember']);
          return of(false);
        }
      })
    );
  }
}
